import React from "react";
import { ArrowBackCircle } from 'react-ionicons'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@popperjs/core"
import constantURI from "../URI"
import _post from "../Functions/Post"
import stylesASAP from "./stylesASAP"
import ASAPAuthenticate from "../Functions/ASAPAuthenticate"
import stylesMed from "../MedRep/stylesMed"
import { db } from '../firebase';

export default class MoreInfo extends React.Component {

    constructor() {
        super();
        this.state = {
            HCP: "",
            details: [{ name: "Name" }, { name: "Type" }, { name: "Phone" }, { name: "Email" },
            { name: "Mobile" }, { name: "Street" }, { name: "Street2" }, { name: "Country" }, { name: "city" }, { name: "State" }, { name: "Zip Code" }, { name: "Currency" },
            { name: "Code" }, { name: "Tax Id" }, { name: "Adress Type" }, { name: "Group" }, { name: "Website Link" }, { name: "Job Position" }, { name: "Title" }, { name: "Category" }],
            showVisits: false,
            items: [],
            itemsCopy: [],
            loading: true,
            token: "",
            isHistory: false,
            historyName: "",
            previousVisits: [],
            showDetail: [],
            user: "",
            authenticate: false,
            alertUndefined: false,
            detail: "",
            userId: -1
        }
    }

    async componentDidMount() {
        document.body.style.backgroundColor = "#e6e6fa";

        await ASAPAuthenticate().then((response) => { this.setState({ authenticate: response }) });
        const client = localStorage.getItem('moreinfo');
        const token = localStorage.getItem("Token");
        const userId = localStorage.getItem('UserId');
        await this.setState({ HCP: JSON.parse(client), token: JSON.parse(token), userId: JSON.parse(userId) });

        const getClientByName = constantURI() + "GetClientByName?token=" + this.state.token + "&name=" + this.state.HCP;
        const getClients = constantURI() + "GetClients?token=" + this.state.token + "&user=" + this.state.userId;
        if (this.state.authenticate) {
            await _post(getClientByName).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ items: data.result, itemsCopy: data.result, loading: false })
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(getClients).then((response) => {
                return response.json().then(async (data) => {
                    if (data.result !== undefined) {
                        await localStorage.setItem('Clients', JSON.stringify(data.result));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })

        }
        else {
            await this.readData();
            this.state.detail.map((item, index) => {
                if (item.name === this.state.HCP) {
                    var temp = [];
                    temp.push(item);
                    this.setState({ items: temp, loading: false })
                }
            })
        }
    }

    readData = async () => {
        var temp = [];
        await db.collection("Clients").get().then((querySnapshot) => {
            var lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];
            console.log("last", lastVisible);

            querySnapshot.forEach((doc) => {

                console.log(doc.data());
                temp.push(doc.data());
                this.setState({ detail: doc.data().client, loading: false })
            })
            /*lastVisible.ref.update*/
            this.setState({ last: lastVisible })
        })
    }

    render() {
        if (!this.state.loading) {
            return (
                <div className="container-fluid" style={stylesASAP.mainContainer}>
                    {(!this.state.alertUndefined) ?
                        null :
                        <div className="col alert alert-danger">
                            <div className="row">
                                <h6 className="col-sm-8">There seems to be a problem.</h6>
                                <div className="col d-flex flex-row-reverse">
                                    <div className="btn" style={stylesMed.wideButton} onClick={() => window.location.reload()}>Reload</div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="row pt-3">
                        <div className="col">
                            <ArrowBackCircle className="btn" onClick={async () => { this.props.history.push("/Client"); }} color={'#00bfff'} height="50px" width="50px" />
                        </div>

                        <div className="col"></div>
                    </div>
                    <div className="mt-4"></div>
                    <div>
                        {this.state.details.map((item, index) => {
                            return (
                                <div key={index}>
                                    <div className="row justify-content-center align-content-center m-1" style={stylesASAP.clientDetailCard}>
                                        <h4 className="col-sm-4 mt-1">{item.name}:</h4>
                                        <p className="col-sm-8 mt-1" style={{ fontSize: 20 }}>
                                            {this.state.items.map((item2) => {
                                                if (index === 0)
                                                    return item2.name
                                                else if (index === 1)
                                                    return item2.partnertype_id
                                                else if (index === 2)
                                                    return item2.phone
                                                else if (index === 3)
                                                    return item2.email
                                                else if (index === 4)
                                                    return item2.mobile
                                                else if (index === 5)
                                                    return item2.street
                                                else if (index === 6)
                                                    return item2.street2
                                                else if (index === 7)
                                                    return item2.country_id
                                                else if (index === 8)
                                                    return item2.city
                                                else if (index === 9)
                                                    return item2.state_id
                                                else if (index === 10)
                                                    return item2.zip
                                                else if (index === 11)
                                                    return item2.currency_id
                                                else if (index === 12)
                                                    return item2.ref
                                                else if (index === 13)
                                                    return item2.vat
                                                else if (index === 14)
                                                    return item2.type
                                                else if (index === 15)
                                                    return item2.partnergroup_id
                                                else if (index === 16)
                                                    return item2.website
                                                else if (index === 17)
                                                    return item2.function
                                                else if (index === 18)
                                                    return item2.title
                                                else if (index === 19)
                                                    return item2.partnercategory_id
                                                else if (index === 20)
                                                    return ""
                                                //else if (index === 20 && item2.prefered_visit_time != 0)
                                                //    return convertNumToTime(item2.prefered_visit_time)
                                                else return null
                                            })
                                            }
                                        </p>
                                    </div>
                                </div>
                            )
                        })
                        }
                    </div>
                </div>
            )
        }
        else {
            return (
                <div className="container-fluid vh-100" style={stylesASAP.mainContainer}>
                    <div className="pt-3">
                        <ArrowBackCircle className="btn" onClick={() => this.props.history.push("/Client")} color={'#00bfff'} height="50px" width="50px" />
                    </div>
                    <div className="pt-3 text-center">
                        <div className="spinner-border" style={stylesASAP.spinner}></div>
                    </div>
                </div>
            )
        }
    }
}
